var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
var Orientation = createContext("vertical");
export function useOrientation() {
    return useContext(Orientation);
}
export function OrientationProvider(_a) {
    var orientation = _a.orientation, children = _a.children;
    return (_jsx(Orientation.Provider, __assign({ value: orientation }, { children: children }), void 0));
}
//# sourceMappingURL=Orientation.js.map